<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-content>
          <md-table
            md-fixed-header
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="kiosks">Per page</label>
                <md-select v-model="pagination.perPage" name="kiosks">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >{{ item }}</md-option>
                </md-select>
              </md-field>

              <md-field>
                <md-button
                  style="margin-bottom : 7px; background-color: rgb(31, 71, 154) !important;"
                  class="md-primary md-round md-small"
                  @click="newKiosk"
                >Add a new Kiosk</md-button>
              </md-field>

              <md-field>
                <md-input
                  type="search"
                  class="mb-3"
                  clearable
                  style="width: 200px"
                  placeholder="Search records"
                  v-model="searchQuery"
                ></md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Kiosk" md-sort-by="name">{{ item.slug }}</md-table-cell>
              <!-- <md-table-cell md-label="Qr Code">
                <div class="icon" @click="downloadQr(item)">
                  <md-icon class="qr_icon">qr_code</md-icon>
                </div>
                <div :ref="item.id" class="qr">
                  <vue-qr
                    :size="300"
                    :text="
                      'https://dellsdestinations.com/initialize/' + item.id
                    "
                  ></vue-qr>
                </div>
              </md-table-cell> -->
              <!-- <md-table-cell md-label="Last Signal" md-sort-by="last_signal">
                {{ item.last_signal }}
              </md-table-cell>-->
              <!-- <md-table-cell v-if="item.uploadedBy == currentUser" md-label="Default">
                <md-switch @change="updateDefault(item)" v-model="item.default" :value="true">
                  <span>{{item.default ? 'Yes': 'No'}}</span>
                </md-switch>
              </md-table-cell>-->
              <md-table-cell md-label="URL" md-sort-by="slug">
                <p @click="openLink(item.slug)" class="icon_txt">
                  {{ item.slug }}
                  <md-button class="md-just-icon md-warning md-simple">
                    <md-icon>link</md-icon>
                  </md-button>
                </p>
              </md-table-cell>
              <!-- <md-table-cell md-label="Reports">
                <md-button
                  class="md-just-icon md-warning md-simple"
                  @click='goToReports(item)'
                >
                  <md-icon>signal_cellular_alt</md-icon>
                </md-button>
              </md-table-cell>-->
              <md-table-cell md-label="Edit">
                <md-button
                  class="md-just-icon md-warning md-simple"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>edit</md-icon>
                </md-button>
              </md-table-cell>
              <md-table-cell md-label="Delete">
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                >
                  <md-icon style="color: rgb(31, 71, 154) !important">close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import { db } from "@/config/firebaseInit";
import Swal from "sweetalert2";
import router from "@/router";
import QrcodeVue from "qrcode.vue";
import VueQr from "vue-qr";

export default {
  components: {
    Pagination,
    QrcodeVue,
    VueQr
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      currentSort: "name",
      currentSortOrder: "asc",
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [50, 100, 200, 500],
        total: 0
      },
      footerTable: ["Kiosk", "Description", "Location", "Edit", "Delete"],
      searchQuery: "",
      propsToSearch: ["description", "last_signal", "slug"],
      tableData: [],
      searchedData: [],
      fuseSearch: null
    };
  },
  firestore() {
    return {
      tableData: db.collection("kiosk")
    };
  },
  methods: {
    downloadQr(item) {
      var link = document.createElement("a");
      link.download = item.slug + ".png";
      link.href = this.$refs[item.id].children[0].src;
      link.click();
    },
    updateDefault(item) {
      db.collection("kiosk")
        .doc(item.id)
        .update({ default: item.default });

      this.tableData.forEach(async data => {
        if (data.id !== item.id) {
          data.default = false;
          await db
            .collection("kiosk")
            .doc(data.id)
            .update({ default: false });
        }
      });
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    newKiosk() {
      let ref = db.collection("kiosk").doc();
      this.handleEdit(ref);
    },
    handleEdit(item) {
      let id = item.id;
      router.push(`/kiosks/${id}`);
    },
    handleDelete(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to undo this",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL"
      }).then(result => {
        if (result.value) {
          return db
            .collection("kiosk")
            .doc(item.id)
            .delete()
            .then(() => {
              Swal.fire("Deleted!", "The page has been deleted.", "success");
            });
        }
      });
    },
    openLink(slug) {
      window.open("https://consume-cannabis.firebaseapp.com/" + slug, "_bank");
    }
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["name", "url"],
      threshold: 0.3
    });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
.icon {
  height: 30px;
  width: 30px;
}
.qr_icon {
  cursor: pointer;
  color: #3581ef !important;
}

.qr {
  position: fixed;
  z-index: -10;
  opacity: 0;
}
</style>
